var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"transition":"slide-x-reverse-transition","max-width":"640"},model:{value:(_vm.dialogModel),callback:function ($$v) {_vm.dialogModel=$$v},expression:"dialogModel"}},[_c('ContentAttachments',{attrs:{"active":_vm.active,"lesson-id":_vm.lessonId,"schedule-id":_vm.scheduleId,"show-close":""},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }